import { Transforms, Node } from 'slate';

import HelptapEditor from '../../helpers';

function withColumnRestrictions(editor) {

  const { normalizeNode } = editor;

  editor.normalizeNode = ([node, path]) => {
    // Check if the node is a 'column' node
    if (node.type === 'column') {
      const children = Array.from(Node.children(editor, path));
      // Iterate over the children of the column node
      for (const [child, childPath] of children) {
        // Define the allowed types for children of a column
        const notAllowedTypes = ['column'];

        // If the child's type is not in the allowedTypes array, remove it
        if (notAllowedTypes.includes(child.type)) {
          Transforms.removeNodes(editor, { at: childPath });
          return; // Return early to re-trigger normalization
        }
      }
      // Ensure column always has at least one node
      if (children.length === 0) {
        const paragraphNode = HelptapEditor.paragraph.buildNode();
        Transforms.insertNodes(editor, paragraphNode, { at: path.concat(0) });
        return;
      }
    }

    // If no violations were found, or the node is not a 'column', continue with the next normalization rule
    normalizeNode([node, path]);
  };

  return editor;

};

export default withColumnRestrictions;